import { Navigate, useLocation } from 'react-router-dom'

import type { TenantFeatureKey } from '@/constants/tenant-features'
import { STUDIO_BASE } from '@/features/studio/lib/studio-paths'
import { useTenantFeatures } from '@/hooks'

function studioFeatureForPath(pathname: string): TenantFeatureKey | null {
  const path = pathname.split('?')[0] ?? pathname
  if (path.startsWith('/studio/productions')) return 'studio_production'
  if (path.startsWith('/studio/writer')) return 'studio_writer'
  if (path.startsWith('/studio/creative')) return 'studio_creative'
  if (path.startsWith('/studio/invites')) return 'studio_production'
  return null
}

/** 创作中心子路由按 studio_* 模块键守卫 */
export function StudioFeatureGuard({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation()
  const { isEnabled, loading } = useTenantFeatures()
  const required = studioFeatureForPath(pathname)

  if (loading || !required) {
    return <>{children}</>
  }

  if (!isEnabled(required)) {
    return <Navigate to={STUDIO_BASE} replace />
  }

  return <>{children}</>
}
